<template>
  <el-sub-menu index="1" class="header_language" style="height: max-content">
    <template #title>
      <div class="tw-flex tw-gap-[4px] tw-items-center">
        <img
          :src="locales.find((el) => el.key === selected_locale)?.icon"
          class="tw-h-[21px] tw-object-contain"
          alt="language"
          width="21"
          height="15"
        />
        <span
          class="tw-text-[#181818] tw-text-[12px] tw-font-normal tw-leading-[150%] tw-m-0 tw-p-0"
          >{{ locales.find((el) => el.key === selected_locale)?.title }}</span
        >
      </div>
    </template>
    <el-menu-item
      :index="locale.key"
      @click="handleLocaleChange(locale.key)"
      v-for="(locale, index) in locales"
      :key="`locale-${locale.key}`"
      class="tw-flex tw-gap-2"
    >
      <img :src="locale.icon" alt="" />
      <span>
        {{ locale.full_title }}
      </span>
    </el-menu-item>
  </el-sub-menu>
</template>

<script setup lang="ts">
import uzFlag from "@/assets/images/icons/uz-flag.svg";
import { ref } from "vue";
import { useTranslate } from "~/composables/useTranslate";
import { setItem } from "~/shared/localstorage.util";
import { toCyrill } from "~/shared/translate";

const { locale } = useTranslate();
const selected_locale = ref(locale.value);

const locales = [
  {
    icon: uzFlag,
    title: "O'z",
    full_title: "O'zbek",
    key: "uz",
  },
  {
    icon: uzFlag,
    title: toCyrill("O'z"),
    full_title: toCyrill("O'zbek"),
    key: "oz",
  },
];

function handleLocaleChange(localeKey: string) {
  locale.value = localeKey;
  selected_locale.value = localeKey;
  setItem("lang", localeKey);
}
</script>

<style scoped>
:global(
    .ep-menu--horizontal > .ep-sub-menu.is-active .ep-sub-menu__title,
    .ep-sub-menu.is-active .ep-sub-menu__title
  ) {
  border-bottom: none !important;
  color: inherit !important;
}
</style>
